const ONES = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
const TEENS = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
const TENS = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

function convertGroup(n: number): string {
    let str = '';
    
    // Hundreds
    if (n >= 100) {
        str += ONES[Math.floor(n / 100)] + ' Hundred';
        n %= 100;
        if (n > 0) str += ' ';
    }
    
    // Tens and Ones
    if (n > 0) {
        if (n < 20) {
            str += TEENS[n - 10] ? TEENS[n - 10] : ONES[n];
        } else {
            str += TENS[Math.floor(n / 10)];
            if (n % 10 > 0) str += ' ' + ONES[n % 10];
        }
    }
    return str;
}

export function numberToWords(amount: number, currency: string = 'USD'): string {
    if (amount === 0) return 'ZERO';

    // Split integer and decimal
    const integerPart = Math.floor(amount);
    
    let words = '';
    
    if (integerPart === 0) {
        words = 'Zero';
    } else {
        const billions = Math.floor(integerPart / 1000000000);
        const millions = Math.floor((integerPart % 1000000000) / 1000000);
        const thousands = Math.floor((integerPart % 1000000) / 1000);
        const remainder = integerPart % 1000;

        if (billions > 0) words += convertGroup(billions) + ' Billion ';
        if (millions > 0) words += convertGroup(millions) + ' Million ';
        if (thousands > 0) words += convertGroup(thousands) + ' Thousand ';
        if (remainder > 0) words += convertGroup(remainder);
    }

    words = words.trim().toUpperCase();

    // Map currency codes to full names
    let currencyName = currency;
    if (currency === 'TZS') currencyName = 'TANZANIA SHILLINGS';
    if (currency === 'UGX') currencyName = 'UGANDA SHILLINGS';
    if (currency === 'KES') currencyName = 'KENYA SHILLINGS';
    if (currency === 'USD') currencyName = 'US DOLLARS';
    if (currency === 'EUR') currencyName = 'EUROS';
    if (currency === 'GBP') currencyName = 'POUNDS STERLING';
    
    return `${currencyName} ${words} ONLY`;
}

/**
 * Adds business days (skipping Sat/Sun) to a start date.
 */
export function addBusinessDays(startDate: Date, days: number): Date {
  const date = new Date(startDate.getTime());
  let addedDays = 0;
  while (addedDays < days) {
    date.setDate(date.getDate() + 1);
    const dayOfWeek = date.getDay();
    if (dayOfWeek !== 0 && dayOfWeek !== 6) { // 0 = Sunday, 6 = Saturday
      addedDays++;
    }
  }
  return date;
}
